import { ILanguage } from "../../interfaces/ILanguage";

export const sv: ILanguage = {
  // General
  Add: "Lägg till",
  Added: "Tillagd",
  Included: "Inkluderad",
  NotAvailable: "Ej tillgängligt",
  Home: "Hem",

  // Error handling
  RequiredField: "Vänligen, fyll i detta fält",
  PhoneNumberMustBe10Digits:
    "Telefonnummer måste vara 10 siffror (XXX XXX XX XX)",
  ZipNumberMustBe5Digits: "Postnummer måste vara 5 siffror (XXX XX)",

  // Order
  SubscriptionDetails: "Paketdetaljer",
  OrganisationDetails: "Organisationsuppgifter",
  InvoiceDetails: "Fakturauppgifter",

  Subscription: "Paket",
  NumberOfUsers: "Antal användare",
  OrganisationNumber: "Organisationsnummer",
  OrganisationNumberPlaceholder: "55123456-7890",
  OrganisationName: "Organisationsnamn",
  OrganisationNamePlaceholder: "365Robust AB",
  OrganisationType: "Organisationsform",
  OrganisationTypePlaceholder: "Aktiebolag",
  NumberOfEmployees: "Antal anställda",
  Snis: "SNI-Koder",
  SnisPlaceholder: "62010, 62020, 43290, ...",
  NumberOfWorkplaces: "Antal arbetsställen",

  InvoiceName: "Fakturnamn",
  InvoiceNamePlaceholder: "365Robust AB",
  InvoiceAddress: "Fakturaadress",
  InvoiceAddressPlaceholder: "Virkesvägen 13a",
  InvoiceReference: "Fakturareferens",
  InvoiceReferencePlaceholder: "R365-12345",
  PostalCode: "Postadress",
  PostalCodePlaceholder: "120 78",
  County: "Ort",
  CountyPlaceholder: "Stockholm",
  PhoneNumber: "Telefonnummer",
  PhoneNumberPlaceholder: "070-123 45 67",
  Email: "E-post",
  EmailPlaceholder: "info@365robust.se",
  OtherInvoiceDetails: "Övriga fakturauppgifter",
  OtherInvoiceDetailsPlaceholder: "",

  // Basket
  Basket: "Varukorg",
  Product: "Produkt",
  Quantity: "Antal",
  MonthlyCost: "Månadskostnad",
  TotalMonthlyCost: "Total månadskostnad",
  StartingFee: "Uppstartskostnad",
  Addon: "Tillägg",
  Addons: "Tillägg",
  Users: "Användare",
  Workplaces: "Arbetsställen",
  Other: "Övrigt",
  OneTimeFee: "Engångskostnad",

  // Order confirm
  ThankYouForYourOrder: "Tack för din beställning",
  WeHaveReceivedYourOrder: "Vi har mottagit din beställning",
  WeWillContactYouSoon:
    "Vi kontaktar er så snart vi har hanterat er beställning",

  CurrencyPerMonth: "kr/mån",
  CurrencyShortForm: "kr",
  Next: "Nästa",
  Back: "Tillbaka",
  ConfirmOrder: "Bekräfta beställning",
  OrderDetails: "Orderdetaljer",
  ContactInformation: "Kontaktinformation",

  Information: "Information",
  Order: "Beställ",

  // Packages
  OPTIMAL: "Optimal",
  STOR: "Stor",
  GRUNDLAGGANDE: "Grundläggande",
  MINIMAL: "Minimal",
  STARTUP: "Startup (utan anställda)",
  CUSTOM: "Anpassat",

  ChooseOneOfOurPackages:
    "Välj något av våra populära paket, eller kontakta oss för en offert.",
  WhichSubscriptionLevelShouldIChoose: "Vad ingår i paketen och modulerna?",
  MostPopular: "Mest populär!",
  Demands: "Krav",
  DemandModule: "Kravmodul ~",
  Process: "Process",
  ProcessPlural: "Processer",
  AllProcesses: "(alla)",
  Workplace: "Arbetsställe",
  WorkplacePlural: "Arbetsställen",
  ShowMorePackages: "Visa fler paket",
  HidePackages: "Dölj paket",
  NoPackageSuitsYou: "Passar inget av paketen?",
  ContactUsForQuote: "Kontakta oss för en offert",

  // Order addons
  BaseModules: "Basmoduler",
  ComplianceAreas: "Processer",
  Modules: "Moduler",
  ProcessesSelectedCount: "{{count}} valda · {{included}} ingår i paketet",
  ProcessesIncludedCount: "{{count}} av {{total}} inkluderade i ditt paket",
  Processes: "Processer",
  RequiresBaseModule: "Kräver basmodul: {{name}}",

  // Policy / legal
  PolicyAcceptance:
    "Jag accepterar att 365Robust AB lagrar mina uppgifter och kontaktar mig utifrån dessa",

  // Error page
  PageLoadError: "Sidan hämtades inte som tänkt",
  ErrorMessageLabel: "Felmeddelande:",
  GoToStart: "Till startsidan",
  ErrorHeadline: "Just nu är hemsidan nere",
  ErrorBody:
    "Vi arbetar med det och sidan är snart tillbaka igen. Testa gärna igen om en liten stund – vi ser fram emot att visa vad 365Robust kan göra för er.",
  NotFoundHeadline: "Vi hittar inte sidan du söker",
  NotFoundBody:
    "Sidan kan ha flyttat eller tagits bort. Testa startsidan – eller titta direkt på hur 365Robust kan hjälpa er.",
  ErrorRetry: "Försök igen",
  ErrorSeePackages: "Se våra paket",

  // Login
  WelcomeTitle: "Välkommen till 365Robust.se",
  SignIn: "Logga in",

  // Contact details
  FillInYourContactDetails:
    "Fyll i dina kontaktuppgifter så tar vi kontakt med dig för att upprätta konto och signera avtal.",
  FirstName: "Förnamn",
  FirstNamePlaceholder: "Kalle",
  LastName: "Efternamn",
  LastNamePlaceholder: "Karlsson",
  OtherInformation: "Övrig information",
};
